import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cf0aaea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5cf0aaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0aaea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf0aaea')) {
      api.createRecord('5cf0aaea', component.options)
    } else {
      api.reload('5cf0aaea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5cf0aaea&scoped=true&", function () {
      api.rerender('5cf0aaea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/analytics/pairs/index.vue"
export default component.exports